export namespace Navigation {
    /**
     * 业务数据参数key
     */
    export const BizDataParamKey = '__parameters';
    /**
     * 导航目标类型
     */
    export const enum ModuleType {
        Workbench, // 工作台
        Application, // 应用
        Form_View, // 查看表单
        Form_New, // 新建表单
    }

    /**
     * 打开链接目标类型
     */
    export const enum TargetType {
        Blank, // 新开页面
        Self, // 当前页面刷新
    }

    /**
     * 导航模型
     */
    export interface TransferModel {
        appCode?: string;
        schemaCode: string;
        bizObjectId?: string;
        to: ModuleType;
        target: TargetType;
        isNX: boolean;
        isFormV3?: boolean; // 是否是表单v3
        isSaaS?: boolean; // 是否是saas企业
        isExternal?: boolean; // 是否是外链表单
    }
}
